import React from "react";

export default function PopoverMenuSeparator() {

    return (
        <div className="separator"/>
    )

}